/**
 * Semantic color tokens for EHR Dashboard styling.
 * Use these constants instead of inline hex colors to ensure consistent styling.
 */

// Primary brand colors
export const METRIPORT_PRIMARY = "#4b6beb";
export const METRIPORT_PRIMARY_HOVER = "#3a5ad9";
export const METRIPORT_PRIMARY_ACTIVE = "#2f4cc4";

// Semantic colors
export const COLOR_ERROR = "#cf222e";
export const COLOR_SUCCESS = "#1a7f37";
export const COLOR_WARNING = "#9a6700";

// Text colors
export const TEXT_PRIMARY = "gray.900";
export const TEXT_SECONDARY = "gray.700";
export const TEXT_MUTED = "gray.600";

// Background colors
export const BG_OVERLAY = "blackAlpha.700";
